// frontend/src/components/MlExperiment/MlExperiment.tsx

import React, { useEffect } from 'react';
import { useMlExperiment } from '../../hooks/useMlExperiment';
import { useAuth } from '../../contexts/AuthContext';
import { MlExperimentSelector } from './MlExperimentSelector';
import { MlExperimentStats } from './MlExperimentStats';
import { MlExperimentSummary } from './MlExperimentSummary';
import { MlExperimentDetails } from './MlExperimentDetails';
import { MlExperimentDecision } from './MlExperimentDecision';
import './MlExperiment.css';

export const MlExperiment: React.FC = () => {
  const { selectedTraceId, selectedDataset: authDatasetName } = useAuth();

  const {
    experiments,
    selectedExperiment,
    analysis,
    summary,
    loading,
    error,
    selectExperiment,
    listExperiments,
    loadSummary,
  } = useMlExperiment();

  useEffect(() => {
    listExperiments();
    loadSummary();
  }, [listExperiments, loadSummary]);

  if (loading && !analysis) {
    return (
      <div className="ml-container">
        <div className="loading-state">🤖 Carregando experimentos ML...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ml-container">
        <div className="error-state">❌ {error}</div>
      </div>
    );
  }

  return (
    <div className="ml-container">
      <div className="ml-header">
        <h1>🤖 Experimentos ML</h1>
        <p className="subtitle">Resultados e decisões dos experimentos de Machine Learning</p>
      </div>

      {summary && <MlExperimentSummary summary={summary} />}

      {/* Só exibe o seletor se NÃO houver trace selecionado globalmente */}
      {!selectedTraceId ? (
        <MlExperimentSelector
          experiments={experiments}
          selectedExperiment={selectedExperiment}
          onSelect={selectExperiment}
          loading={loading}
        />
      ) : (
        <div style={{
          background: 'rgba(79, 195, 247, 0.1)',
          border: '1px solid #4fc3f7',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '24px',
          color: '#4fc3f7',
        }}>
          <span>
            Dataset em foco: <strong>{analysis?.dataset_name || selectedExperiment?.dataset_name || authDatasetName || 'Carregando...'}</strong>
          </span>
          <div style={{ fontSize: '11px', marginTop: '4px', color: '#8899aa' }}>
            Para alterar o dataset, acesse a tela "Meus Dados".
          </div>
        </div>
      )}

      {/* Se não houver análise mas houver experimentos, mostra uma mensagem */}
      {!analysis && experiments.length === 0 && selectedTraceId && (
        <div className="error-state" style={{ padding: '20px', marginTop: '16px' }}>
          Nenhum experimento encontrado para o trace selecionado.
        </div>
      )}

      {analysis && (
        <>
          <MlExperimentStats analysis={analysis} />
          <MlExperimentDecision analysis={analysis} />
          <MlExperimentDetails analysis={analysis} />
        </>
      )}
    </div>
  );
};

export default MlExperiment;